module.exports = __webpack_public_path__ + "img/order-filter-inactive.f379f740.svg";